<template>
  <main>
    <div class="container-fluid pt-3">

      <div class="card shadow-lg ">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{email}}</h5>
                <p class="mb-0 font-weight-bold text-sm">{{auth}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-lg-6 col-12  mb-4">
          <div class="card">
            <div class="card-body"  v-if="step=='1'">
              <p class="text-uppercase text-sm">지갑주소</p>
              <div class="row">
                <div class="col-12">
                  <label for="example-text-input" class="form-control-label">지갑주소</label>
                  <input class="form-control" type="text" v-model="address" readonly />
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">TRON 보유개수 </label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="tron_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckTRONBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">USDT 보유개수 </label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="usdt_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckUSDTBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">MCS 보유개수 </label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="mcs_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckMCSBalance">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button type="button"  class="btn btn-lg mt-3 mb-0 ms-auto btn-danger" @click="GotoNext(2)">코인 전송</button>
                </div>
              </div>
            </div>

            <div class="card-body" v-if="step=='2'">
              <p class="text-uppercase text-sm">코인 전송</p>
              <div class="row">
                <div class="col-12">
                  <label for="example-text-input" class="form-control-label">지갑주소</label>
                  <input class="form-control" type="text" v-model="address" readonly />
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">TRON 보유개수</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="tron_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckTRONBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">USDT 보유개수</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="mcs_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckUSDTBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <label for="example-text-input" class="form-control-label">전송 코인</label>
                  <select v-model="coin" class="form-control" >
                    <option value ="TRON">TRON</option>
                    <option value ="USDT">USDT</option>
                    <option value ="MCS">MCS</option>
                  </select>
                </div>
                <div class="col-12">
                  <label for="example-text-input" class="form-control-label">받을 지갑주소</label>
                  <input class="form-control" type="text" v-model="to_address"/>
                </div>
                <div class="col-12">
                  <label for="example-text-input" class="form-control-label">전송 개수</label>
                  <input class="form-control" type="text" v-model="to_balance"/>
                </div>

                <div class="col-12">
                  <button type="button"  class="btn btn-lg mt-3 mb-0 ms-auto btn-warning" @click="WithdrawCheck()">전송 확인</button>
                </div>
              </div>
            </div>

            <div class="card-body" v-if="step=='3'">
              <p class="text-uppercase text-sm">코인 전송</p>
              <div class="row">
                <div class="col-12">
                  <label for="example-text-input" class="form-control-label">받을 지갑주소</label>
                  <input class="form-control" type="text" v-model="to_address" readonly/>
                </div>
                <div class="col-12">
                  <label for="example-text-input" class="form-control-label">전송 개수</label>
                  <input class="form-control" type="text" v-model="to_balance" readonly/>
                </div>
                <div class="col-12" v-if='auth_email ==false'>
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">메일 인증코드</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="email_code" />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckEmailAuth()">
                        <i class="fa fa-send"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button type="button"  class="btn btn-lg mt-3 mb-0 ms-auto btn-warning" @click="WithdrawConfirm()">전송하기</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</template>

<script>
import { mapMutations } from "vuex";
const CryptoJS = require("crypto-js");
export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      email : '',
      auth : '',
      address : '',
      tron_balance : '',
      usdt_balance : '',
      mcs_balance : '',
      add_memo : '',
      sub_balance :'',
      sub_memo : '',
      memo : '',
      admin_histroy_list : [],
      old_password : '',
      password:'',
      password_confirm :'',
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile,
      auth_list : [],
      step : 1,
      to_address : '',
      to_balance : '',
      email_code : '',
      auth_email : false,
      coin :'TRON',
    };
  },
  components: {},

  mounted() {
    // this.GetAdminHistroy();
    this.GetProfile();

    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = false;
    this.$store.state.isAbsolute = false;
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      }
    }
  },
  methods:{
    CheckTRONBalance(){
      this.axios.post('/admin/coin/GetWalletTRONBalance', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.balance = body.wallet.balance;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    CheckUSDTBalance(){
      this.axios.post('/admin/coin/GetWalletUSDTBalance', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.balance = body.wallet.balance;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    CheckMCSBalance(){
      this.axios.post('/admin/coin/GetWalletMCSBalance', {}).then(
          res => {
            if(res.status ==200){
              if(res.data.code=='200'){
                const e_body = res.data.body;
                const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
                const d_res = bytes.toString(CryptoJS.enc.Utf8);
                const body = JSON.parse(d_res)
                this.mcs_balance = body.wallet.balance;
              }else if(res.data.code=='9999'){
                this.$store.dispatch('SETLOGOUT').then(
                    ()=>{
                      window.location.href="/login";
                    }
                )
              }
            }
          }
      )
    },
    GotoNext(step){
      this.step =step;
    },
    ...mapMutations(["navbarMinimize"]),
    GetProfile(){
      this.axios.post('/admin/coin/GetProfile', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){

              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.email = body.email;
              this.auth = body.auth;
              this.address = body.wallet.address;
              this.tron_balance = body.wallet.balance;

              this.usdt_balance = body.usdt_balance;
              this.mcs_balance = body.mcs_balance;

            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    CheckBalance(){
      this.axios.post('/admin/coin/GetWalletBalance', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.balance = body.wallet.balance;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    WithdrawCheck(){
      const to = this.to_address;
      const balance = this.to_balance;

      const body = {to,balance};

      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      let url = '/admin/coin/WithdrawCheckTRON';
      if(this.coin =='TRON'){
        url = '/admin/coin/WithdrawCheckTRON';
      } else if(this.coin === 'USDT') {
        url = '/admin/coin/WithdrawCheckUSDT';
      } else {
        url = '/admin/coin/WithdrawCheckMCS';
      }

      this.axios.post(url, {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){

              this.$alert.alert("이메일로 인증코드가 전송되었습니다.").then(
                ()=>{
                  this.step =3;
                }
              )
            }else if(res.data.code=='100'){

              this.$alert.alert("보유금액이 부족합니다.").then(
                ()=>{
                  this.step =2;
                }
              )
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      ).catch(
        ()=>{
          this.$alert.alert("지갑주소를 확인해주세요.");
          this.step = 2;
        }
      )
    },
    CheckEmailAuth(){

      const code = this.email_code;

      if(code ==''){
        this.$alert.alert("이메일 인증코드를 입력해주세요.")
        return false;
      }
      const body = {code};

			const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/coin/email_certification', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.auth_email = true;
              this.$alert.alert("인증되었습니다.");
            }else if(res.data.code=='100'){
              this.$alert.alert("인증 코드를 다시 확인해주세요.")
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    WithdrawConfirm(){
      const to = this.to_address;
      const balance = this.to_balance;
      const body = {to,balance};

      if(this.auth_email ==false){
        this.$alert.alert("이메일 인증후 진행해주세요.");
        return false;
      }

      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.loading = true;

      let url = '/admin/coin/WithdrawConfirmTRON';
      if (this.coin === 'USDT') {
        url = '/admin/coin/WithdrawConfirmUSDT';
      } else if (this.coin === 'MCS') {
        url = '/admin/coin/WithdrawConfirmMCS';
      }

      this.axios.post(url, {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.loading = false;
              this.$alert.alert("전송하였습니다.").then(
                ()=>{
                  this.$router.go();
                }
              )
            }else if(res.data.code=='300'){
              this.loading = false;
              this.$alert.alert("인증코드를 확인해주세요.").then(
                ()=>{

                }
              )
            }else if(res.data.code=='100'){
              this.loading = false;
              this.$alert.alert("보유금액을 확인해주세요.");
              this.step = 2;
            }else if(res.data.code=='9999'){
              this.loading = false;
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      ).catch(
        ()=>{
          this.loading = false;
          this.step = 2;
        }
      )
    },

  }
};
</script>
